import { render, staticRenderFns } from "./IconSlimMenu.vue?vue&type=template&id=49f70287&"
import script from "./IconSlimMenu.vue?vue&type=script&lang=ts&"
export * from "./IconSlimMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports